export const HOST_INVOICE_BRANDING = {
  green: "#0D9813",
  greenRgb: [13, 152, 19],
  waveLight: "#E1F8E3",
  waveLightRgb: [225, 248, 227],
  waveDark: "#CAF0CD",
  waveDarkRgb: [202, 240, 205],
  waveHeightMm: 23,
};
